import Quiz from "../components/Quiz/Quiz";

function QuizPage() {
  return (
    <div className="page vertical-page quiz-page">
      <Quiz />
    </div>
  );
}

export default QuizPage;
